<script>
  import API from '../store/config';
  import { layoutOption, queryStr,apiConfig } from '../store/inapp-store'


  const queryString = window.location.search
  $queryStr = queryString

  const urlParams = new URLSearchParams(queryString)
  const mid = urlParams.get('mid')

  // 取得入口串接參數
  fetch(`${$apiConfig.apiUrl}/ct?code=${$apiConfig.apiKey}&mid=${mid}`, {
      method: 'GET'
    })
    .then(response => response.json())
    .then(d => { 
          // 重新開啟首頁
          location.href = '/starbucks?v=1.0.1&ct=' + d.ct
      });
</script>